import { SalesOriginDashboard } from '@/components/origen/SalesOriginDashboard'

export default function OrigenPage() {
  return (
    <div className="relative min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-900">
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center opacity-[0.015]">
        <img src="/nibpr.svg" alt="NIBPR Marca de agua" className="h-96 w-auto select-none" />
      </div>
      <SalesOriginDashboard />
    </div>
  )
}
